import styled from "styled-components";

export const Container = styled.header`
  width: 96%;
  height: 14vh;
  margin-top: 5px;
  margin-bottom: 20px;
  border-radius: 6px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  padding: 0 6vw;
  background-color: var(--black-russian);
  color: var(--white);
  box-shadow: 3px 6px 13px 5px var(--log-cabin);

  div {
    width: 20vw;
    min-width: 168px;
    display: flex;
    justify-content: space-evenly;

    h1 {
      text-shadow: 2px 3px 4px var(--ghost-white);
      text-align: center;
      span {
        padding: 1px 6px;
        text-shadow: 0 0 0;
        font-family: "Yesteryear", cursive;
        font-weight: 200;
        letter-spacing: 0.3rem;
        border: 1px solid var(--dark-goldenrod);
        border-radius: 50%;
        color: var(--dark-goldenrod);
      }
    }
  }

  a {
    width: ;
    color: var(--black-russian);
  }

  .icons {
    width: 80%;
    margin-left: 10vw;
    border-radius: 4px;
    justify-content: flex-end;
    align-items: center;
    background-color: var(--mint-cream);

    svg {
      margin: 0 15px;
      color: var(--black-russian);
    }

    span {
      padding: 4px;
      position: relative;
      top: -14px;
      left: -20px;
      text-align: center;
      font-size: 0.7rem;
      font-weight: 700;
      background-color: var(--red);
      color: var(--white);
      border-radius: 50%;
    }
  }
`;
